import React from 'react';

import PropTypes from 'prop-types';

import { stylePropType, StylableComponent } from '@adsk/alloy-react-helpers';
import theme from '@adsk/alloy-react-theme';

import { Status, statusShape } from '../consts';

type ActivityStatusProps = StylableComponent<HTMLDivElement> & {
  status: Status;
};

/**
 * ActivityStatus component. Describes a single status, containing text & color.
 */
const ActivityStatus = React.forwardRef<HTMLDivElement, ActivityStatusProps>(
  ({ status, style, className, ...props }, ref) => {
    const { text, color, subtext } = status;
    return (
      <div
        ref={ref}
        className={className}
        css={[
          {
            display: 'flex',
            alignItems: 'center',
          },
          style,
        ]}
        {...props}
      >
        <div
          css={[
            {
              minWidth: 3,
              height: subtext ? 32 : 20,
              borderRadius: 4,
              backgroundColor: color,
            },
          ]}
        />
        <div
          css={[
            {
              display: 'flex',
              flexDirection: 'column',
              marginLeft: 8,
            },
          ]}
        >
          <span
            css={[
              theme.typography.labelMedium,
              {
                color: theme.colors.charcoal900,
              },
            ]}
          >
            {text}
          </span>
          {subtext && (
            <span
              css={[
                theme.typography.bodySmall,

                {
                  color: theme.colors.charcoal700,
                },
              ]}
            >
              {subtext}
            </span>
          )}
        </div>
      </div>
    );
  }
);

ActivityStatus.displayName = 'ActivityStatus';

ActivityStatus.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The status */
  status: statusShape.isRequired,
};

export default ActivityStatus;
